export const SYSTEM_MESSAGES_GET_SYSTEM_MESSAGES_TYPES_START = 'SYSTEM_MESSAGES_GET_SYSTEM_MESSAGES_TYPES_START';
export const SYSTEM_MESSAGES_GET_SYSTEM_MESSAGES_TYPES_SUCCESS = 'SYSTEM_MESSAGES_GET_SYSTEM_MESSAGES_TYPES_SUCCESS';
export const SYSTEM_MESSAGES_GET_SYSTEM_MESSAGES_TYPES_FAIL = 'SYSTEM_MESSAGES_GET_SYSTEM_MESSAGES_TYPES_FAIL';

export const SYSTEM_MESSAGES_GET_DATABASES_START = 'SYSTEM_MESSAGES_GET_DATABASES_START';
export const SYSTEM_MESSAGES_GET_DATABASES_SUCCESS = 'SYSTEM_MESSAGES_GET_DATABASES_SUCCESS';
export const SYSTEM_MESSAGES_GET_DATABASES_FAIL = 'SYSTEM_MESSAGES_GET_DATABASES_FAIL';

export const SYSTEM_MESSAGES_GET_SYSTEM_MESSAGE_DATA_START = 'SYSTEM_MESSAGES_GET_SYSTEM_MESSAGE_DATA_START';
export const SYSTEM_MESSAGES_GET_SYSTEM_MESSAGE_DATA_SUCCESS = 'SYSTEM_MESSAGES_GET_SYSTEM_MESSAGE_DATA_SUCCESS';
export const SYSTEM_MESSAGES_GET_SYSTEM_MESSAGE_DATA_FAIL = 'SYSTEM_MESSAGES_GET_SYSTEM_MESSAGE_DATA_FAIL';

export const SYSTEM_MESSAGES_SAVE_SYSTEM_MESSAGE_START = 'SYSTEM_MESSAGES_SAVE_SYSTEM_MESSAGE_START';
export const SYSTEM_MESSAGES_SAVE_SYSTEM_MESSAGE_SUCCESS = 'SYSTEM_MESSAGES_SAVE_SYSTEM_MESSAGE_SUCCESS';
export const SYSTEM_MESSAGES_SAVE_SYSTEM_MESSAGE_FAIL = 'SYSTEM_MESSAGES_SAVE_SYSTEM_MESSAGE_FAIL';

export const SYSTEM_MESSAGES_SAVE_SYSTEM_MESSAGE_IMAGE_START = 'SYSTEM_MESSAGES_SAVE_SYSTEM_MESSAGE_IMAGE_START';
export const SYSTEM_MESSAGES_SAVE_SYSTEM_MESSAGE_IMAGE_SUCCESS = 'SYSTEM_MESSAGES_SAVE_SYSTEM_MESSAGE_IMAGE_SUCCESS';
export const SYSTEM_MESSAGES_SAVE_SYSTEM_MESSAGE_IMAGE_FAIL = 'SYSTEM_MESSAGES_SAVE_SYSTEM_MESSAGE_IMAGE_FAIL';
